<nav class="navbar navbar-expand-sm navbar-light bg-light justify-content-between section-header mb-2">
    <div>
        <span class="navbar-brand mb-0 h1" (click)="logtest()">Site map</span>
    </div>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <div class="navbar-nav ml-auto">
            <!--             <button matTooltip="Save site basic data" type="button" class="btn btn-sm  btn-success "
                [disabled]="!myform.valid||submitted" (click)="saveModel()">
                <i class="far fa-save"></i> Save
            </button> -->
        </div>
        <ul class="nav navbar-nav ml-auto">


            <li class="nav-item mr-1" *ngIf="sitelimitschange">
                <button class="btn btn-outline-success btn-sm " (click)="saveSizeLimits()" role="button" matTooltip="Save new site limits">
                    <i class="fas fa-save"></i> Save site boundary</button>
            </li>
            <li class="nav-item mr-1" *ngIf="sitelimitschange">
                <button class="btn btn-outline-danger btn-sm " (click)="cancelSizeLimits()" role="button" matTooltip="Restore original site limits">
                    <i class="fas fa-edit"></i> Cancel site boundary</button>
            </li>            
<!--             <li class="nav-item mr-1">
                <button class="btn btn-outline-primary btn-sm " (click)="layersShowPanel()" role="button"><i
                        class="fas fa-layer-group"></i></button>
            </li> -->
            <li class="nav-item dropdown" dropdown placement="bottom right">
                <a class="nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
                  aria-expanded="false" dropdownToggle (click)="false">
                  <i class="fas fa-ellipsis-v"></i>
                </a>
                <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown1">
                  <a *ngIf="!sitelimitschange" class="dropdown-item" (click)="showChangeSiteBoundariesDialog()"
                  matTooltip="Edit limits for site."><i class="fas fa-edit"></i> Change site boundary</a>
                   <a *ngIf="!sitelimitschange" class="dropdown-item" (click)="showChangePanelsDialog()"
                  matTooltip="Edit panels for site."><i class="fas fa-edit"></i> Upload Site Panels</a>
                  <a class="dropdown-item" (click)="showChangeDTMDialog()"
                  matTooltip="Upload DTM to the site"><i class="fas fa-edit"></i> Upload DTM</a>
                  <a class="dropdown-item" (click)="showChangeOrthoDialog()"
                  matTooltip="Upload Ortho to the site"><i class="fas fa-edit"></i> Upload Ortho</a>
                </div>
              </li>
        </ul>
    </div>
</nav>
<mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
<app-frms-messagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>
<!-- <ngContainer *ngIf="mapVisible" > -->
    <app-ol-main #map [showCardTitle]="false" [showButtonLayers]="true" [options]="mapcomponent_options"></app-ol-main>
<!-- </ngContainer> -->
